import * as React from "react";

const badgeBaseStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  borderRadius: '9999px',
  padding: '0.125rem 0.625rem',
  fontSize: '0.75rem',
  fontWeight: 500,
  transition: 'colors 0.15s ease',
};

const variantStyles = {
  default: {
    backgroundColor: '#0f172a',
    color: 'white',
    border: '1px solid transparent',
  },
  secondary: {
    backgroundColor: '#f1f5f9',
    color: '#475569',
    border: '1px solid transparent',
  },
  destructive: {
    backgroundColor: '#ef4444',
    color: 'white',
    border: '1px solid transparent',
  },
  outline: {
    backgroundColor: 'transparent',
    color: '#0f172a',
    border: '1px solid #e2e8f0',
  },
  seed: {
    backgroundColor: '#d1fae5',
    color: '#047857',
    border: '1px solid transparent',
  },
  seriesA: {
    backgroundColor: '#dbeafe',
    color: '#1d4ed8',
    border: '1px solid transparent',
  },
  seriesB: {
    backgroundColor: '#ede9fe',
    color: '#7c3aed',
    border: '1px solid transparent',
  },
  seriesC: {
    backgroundColor: '#ffedd5',
    color: '#c2410c',
    border: '1px solid transparent',
  },
  seriesD: {
    backgroundColor: '#fce7f3',
    color: '#be185d',
    border: '1px solid transparent',
  },
  growth: {
    backgroundColor: '#ffe4e6',
    color: '#be123c',
    border: '1px solid transparent',
  },
  preSeed: {
    backgroundColor: '#ecfccb',
    color: '#4d7c0f',
    border: '1px solid transparent',
  },
  debt: {
    backgroundColor: '#fef3c7',
    color: '#b45309',
    border: '1px solid transparent',
  },
};

function Badge({ className, variant = 'default', style, ...props }) {
  return (
    <div 
      style={{ 
        ...badgeBaseStyle, 
        ...(variantStyles[variant] || variantStyles.default),
        ...style,
      }} 
      {...props} 
    />
  );
}

function getFundingBadgeVariant(stage) {
  const stageLower = stage?.toLowerCase()?.trim() || '';
  if (stageLower.includes('pre-seed') || stageLower.includes('preseed')) return 'preSeed';
  if (stageLower.includes('seed')) return 'seed';
  if (stageLower.includes('series a')) return 'seriesA';
  if (stageLower.includes('series b')) return 'seriesB';
  if (stageLower.includes('series c')) return 'seriesC';
  if (stageLower.includes('series d') || stageLower.includes('series e')) return 'seriesD';
  if (stageLower.includes('growth')) return 'growth';
  if (stageLower.includes('debt')) return 'debt';
  return 'secondary';
}

export { Badge, getFundingBadgeVariant };
